/**
  不会出现在菜单中的基本路由
  wk 2020-03-03
*/
const routers = [
	{
		path: '/',
		name: 'login',
		component: () => import('../views/login/index.vue')
	},
	{
		path: '/h5_about',
		name: 'h5_about',
		component: () => import('../views/h5/about.vue')
	},
	{
		path: '/h5_chargeCardList',
		name: 'h5_chargeCardList',
		component: () => import('../views/h5/charge-card-list.vue')
	},
	{
		path: '/h5_chargeCardDetail',
		name: 'h5_chargeCardDetail',
		component: () => import('../views/h5/charge-card-detail.vue')
	},
	{
		path: '/h5_consumptionRecord',
		name: 'h5_consumptionRecord',
		component: () => import('../views/h5/consumption-record.vue')
	},
	{
		path: '/h5_rangeRecord',
		name: 'h5_rangeRecord',
		component: () => import('../views/h5/range-record.vue')
	},
	{
		path: '/h5_rechargeRecord',
		name: 'h5_rechargeRecord',
		component: () => import('../views/h5/recharge-record.vue')
	},
	{
		path: '/h5_policy',
		name: 'h5_policy',
		component: () => import('../views/h5/policy-copy.vue')
	},
	{
		path: '/h5_registerService',
		name: 'h5_registerService',
		component: () => import('../views/h5/register-service-copy.vue')
	},
	{
		path: '/h5_cardExchange',
		name: 'h5_cardExchange',
		component: () => import('../views/h5/exchange/card-exchange-h5.vue')
	},
	{
		path: '/h5_screen',
		name: 'h5_screen',
		component: () => import('../views/dashboard/index-full.vue')
	},
	{
		path: '/h5_app_policy',
		name: 'h5_app_policy',
		component: () => import('../views/h5/policy-app.vue')
	},
	{
		path: '/h5_user_policy',
		name: 'h5_user_policy',
		component: () => import('../views/h5/policy-user.vue')
	},
	{
		path: '/h5_pile_policy',
		name: 'h5_pile_policy',
		component: () => import('../views/h5/policy-pile.vue')
	},
	{
		path: '/h5_leapmotor_guide',
		name: 'h5_leapmotor_guide',
		component: () => import('../views/h5/leapmotor/index.vue')
	},
	{
		path: '/h5_policy_new01',
		name: 'h5_policy_new01',
		component: () => import('../views/h5/h5-policy-new/index-01.vue')
	},
	{
		path: '/h5_policy_new02',
		name: 'h5_policy_new02',
		component: () => import('../views/h5/h5-policy-new/index-02.vue')
	},
	{
		path: '/h5_policy_new03',
		name: 'h5_policy_new03',
		component: () => import('../views/h5/h5-policy-new/index-03.vue')
	},
	{
		path: '/h5_policy_new04',
		name: 'h5_policy_new05',
		component: () => import('../views/h5/h5-policy-new/index-04.vue')
	},
	{
		path: '/h5_policy_new05',
		name: 'h5_policy_new05',
		component: () => import('../views/h5/h5-policy-new/index-05.vue')
	},
]

export default routers
